export default {
  title: 'Invite Job Application',
  label: {
    questionnaire: 'Application Form',
    emailTemplate: 'Email Template'
  },
  message: {
    inviteSuccess: 'Invitation sent successfully',
    inviteFail: 'Failed to send invitation'
  }
}
